import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { toaster } from "../../actions/showToast";

export default function AddImage(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const onClickAddImage = () => {
    console.log("--Add a Image..");
    dispatch(toaster(t("Click a point to add a button"), "warning"));
    props.changeMyTool("addimage");
  };
  return (
    <li onClick={onClickAddImage}>
      <span
        className={`button normal-btn next-page ${
          props.shouldShowButtonLabels ? "show-label-span" : ""
        } ${
          props.activeButton === "addimage" ? "active" : ""
        }`}
        title={t("Add Image")}
        data-tip={t("Add Image")}
      >
        <img
          src={require("../../assets/img/svg/tools-image.svg")}
          alt={t("Add Image")}
        />
        {props.shouldShowButtonLabels && <span className="show-label-text">{t("Image")}</span>}
      </span>
    </li>
  );
}
